import React from 'react';
import {
  Box,
  Card,
  Typography,
  Button,
  IconButton,
  AppBar,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Arrow from '../../assets/backArrow.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import TransactionHistory from './3';
import { useNavigate } from 'react-router-dom';

const TagHistory = ({cardType,balance,setRechargeModal,DeactiveModal}) => {
  const theme = useTheme();
    const navigate=useNavigate()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleOpen=(e)=>{
setRechargeModal(true)

  }
  const handleBack=(e)=>{
  //localStorage.setItem("goToRechargePaymentOption",)
  navigate("/profile")

}

  return (
    <Box sx={{ flexGrow: 1, bgcolor: '#f0f0f0', display:"flex",    justifyContent: "center"
     }}>
      {/* App Bar */}
      <AppBar position="static" sx={{ bgcolor: '#FFD93D'}} style={{height:"10rem",position:"fixed",maxWidth:"450px"}}>
        <Toolbar>
        <img src={Arrow} onClick={handleBack} style={{    width: "25px",
    marginRight:"15px"}}/>
          <Typography variant="h6" color="textPrimary">
            Tag History
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Card */}
      <Box 
      style={{position:"fixed",top: "3rem",width:"100%"}}
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Card
          elevation={3}
          sx={{
            width: isMobile ? '100%' : 400,
            borderRadius: 4,
            p: 2,
            mt: 2,
            bgcolor: '#fff',
          }}
        >
          <Box display="flex" alignItems="center" mb={2}>
            <LocalOfferIcon sx={{ fontSize: 40, color: '#805d93' }} />
            <Box ml={2}>
              <Typography variant="subtitle1" fontWeight="bold">
                0987654322
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {cardType&&cardType}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Balance amount
            </Typography>
        
          </Box>

          <Box display="flex" justifyContent="space-between" mt={2}>
                <Typography variant="h6" fontWeight="bold">
              ₹{balance}
            </Typography>
            <Button variant="contained" sx={{ borderRadius: 999 }} color="success" onClick={(e)=>{handleOpen(e)}}>
              Recharge
            </Button>
          </Box>
        </Card>

      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop:"1rem",
          maxWidth:"400px",
          width:"100%",
          padding:"0%",
          
        }}
        
      >
        <Typography variant="subtitle1" fontWeight="medium">
          Transactions History
        </Typography>
        <Button variant="outlined" size="small" sx={{ borderRadius: 999 }} onClick={DeactiveModal} style={{color:"red",borderColor:"red"}}>
          De-activate
        </Button>
      </Box>
      </Box>
      
      
    </Box>
  );
};

export default TagHistory;
